import { SVGProps } from 'react';

const FlipVertical2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 12H2m8 0H8m8 0h-2m8 0h-2m-3-9-5 5-5-5zm0 18-5-5-5 5z"
    />
  </svg>
);
export default FlipVertical2;
